<div class="modal-body">
    {{ message }}
</div>
<div class="modal-footer">
    <button
        type="button"
        class="btn btn-secondary"
        (click)="activeModal.dismiss('Cross click')"
    >
        Close
    </button>
</div>
